export default "__VITE_ASSET__CzRgEHjs__"